import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, Cell
} from 'recharts';
const barColors = [
"#556B2F",
"#6B8E23",
"#7CFC00",
"#7FFF00",
"#ADFF2F",
"#006400",
"#008000",
"#228B22",
"#00FF00",
"#32CD32",
"#90EE90",
"#98FB98",
"#8FBC8F",
"#00FA9A",
"#00FF7F",
"#2E8B57",
"#66CDAA",
"#3CB371",
"#20B2AA",
"#2F4F4F",
"#008080",
"#008B8B",
"#00FFFF",
"#00FFFF",
"#E0FFFF",
"#00CED1",
"#40E0D0",
"#48D1CC",
"#AFEEEE",
"#7FFFD4",
"#B0E0E6",
"#5F9EA0",
"#4682B4",
"#6495ED",
"#00BFFF",
"#1E90FF",
"#ADD8E6",
"#87CEEB",
"#87CEFA",
"#191970",
"#000080",
"#00008B",
]
class SimpleBarChart extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      Banco: PropTypes.string,
      Afiliaciones: PropTypes.number,
      Meta: PropTypes.number
    })).isRequired,
  }

	render () {
  	return (
      <ResponsiveContainer height={300} width='100%'>
        <BarChart 
          width='100%'
          height={300}
          data={this.props.data}
          layout="horizontal"
          margin={{top: 20, left: -10}}>
          <CartesianGrid strokeDasharray="1 1"/>
          <XAxis dataKey="Banco" interval={0}
                 tick={{fontSize: 10}}
                 tickLine={false}
                 tickMargin={20} />
          <YAxis />
          <Tooltip/>
          <Legend />
          <Bar dataKey="Afiliaciones" barSize="100%" stroke="#3399FF">
            {
              this.props.data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={barColors[index % 20]} />
              ))
            }
          </Bar>

        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default SimpleBarChart;
